import { createContext } from 'react'

import type { Perfil, PermisoModulo } from '@/lib/supabase/tipos-bd'

/** Acciones que se pueden pedir sobre un módulo. Coinciden con las columnas de permisos_modulo. */
export type AccionPermiso = 'ver' | 'crear' | 'editar' | 'aprobar'

export type EstadoSesion = {
  /** Mientras es true no se sabe todavía si hay sesión: no redirigir aún. */
  cargando: boolean
  /** El perfil del usuario, o null si no ha ingresado. */
  perfil: Perfil | null
  /** Permisos del rol del usuario, tal como están en la base. */
  permisos: PermisoModulo[]
  /**
   * Consulta de permiso para la interfaz: decide qué se dibuja y qué se
   * deshabilita. NO es la seguridad — la seguridad son las políticas RLS.
   * Esto solo evita mostrarle a alguien un botón que la base le va a rechazar.
   */
  puede: (modulo: string, accion: AccionPermiso) => boolean
  ingresar: (usuario: string, contrasena: string) => Promise<void>
  salir: () => Promise<void>
}

/**
 * El contexto vive en su propio archivo para que el módulo del proveedor
 * exporte solo componentes: así el recargado en caliente de Vite no pierde el
 * estado en cada guardado.
 */
export const ContextoSesion = createContext<EstadoSesion | null>(null)
